import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { deviceType, osName } from 'react-device-detect';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from '@mui/material';
import React, { useEffect } from 'react';
import { useAuth } from 'contexts/ProtectedRoute';
import ROLE from '../../../assets/userRoles.json';
import useEnabledCountries from 'hooks/useEnabledCountries';
import { ACCOUNT_HOME, selfServeEntryPath } from 'utils/countries';

import { getLocation } from '../../../utils/location';
import { getCookie } from '../../../utils/cookies';
import { AppDispatch, RootState } from '../../../redux/store';

import Questionaire from '../../../views/assessmentPage/Questionnaire/Questionnaire';
import api from 'api';
import { loadUserFullInfo } from 'redux/user/user-middleware';
import * as S from './ConfirmationModal.styled';
import { FrontendEventProps } from 'api/models/payload/EventsPayload';

const country: string = getLocation().userCountry;
const sessionId = getCookie('JSESSIONID');

const ConfirmationModal = () => {
    const user = useSelector((state: RootState) => state.user.entity);
    const { role } = useAuth();
    const { codes } = useEnabledCountries();
    const [open, setOpen] = React.useState(false);
    const dispatch = useDispatch<AppDispatch>();

    const [queryParameters] = useSearchParams();
    const navigate = useNavigate();
    const location = useLocation();

    const trackEventsHandle = async (action: 'preview' | 'submit') => {
        const url_params = window.document.referrer
            ? new URL(window.document.referrer).searchParams
            : null;
        const _eventParams: FrontendEventProps = {
            action: action,
            os_type: osName,
            country: country,
            user_id: `${user.id}`,
            session_id: sessionId,
            device_type: deviceType,
            page_url: location.pathname,
            page_title: 'confirmation_modal',
            referrer: window.document.referrer,
            user_agent: window.navigator.userAgent,
            utm_source: queryParameters.get('utm_source') || url_params?.get('utm_source') || '',
            utm_medium: queryParameters.get('utm_medium') || url_params?.get('utm_medium') || '',
            utm_campaign:
                queryParameters.get('utm_campaign') || url_params?.get('utm_campaign') || '',
            utm_content: queryParameters.get('utm_content') || url_params?.get('utm_content') || '',
            anonymousId: localStorage.ajs_anonymous_id?.replaceAll('"', ''),
        };
        const eventName = 'confirmation_modal';
        const res = await api.events.frontend_event_post(eventName, _eventParams);
        if (res.status !== 200 && res.status !== 201) {
            console.log(res.statusText);
        }
    };

    const handleOpen = () => {
        trackEventsHandle('preview');
        navigate('general');
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };

    useEffect(() => {
        const isUnqualified = role === ROLE.unqualified;
        if (role !== 'CANDIDATE') {
            const path =
                selfServeEntryPath(codes, isUnqualified ? 'unqualified' : 'qualified') ??
                ACCOUNT_HOME;
            if (isUnqualified) {
                navigate(path);
            } else {
                navigate(path, { state: { source: 'confirmationModal' } });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [codes, role]);

    const handleSubmit = async () => {
        await api.assessment.submitAssessment();
        await dispatch(loadUserFullInfo());
        trackEventsHandle('submit');
    };

    return (
        <S.Container>
            <S.Text>
                Please make sure that the Information is <strong>accurate</strong> before
                submitting.
            </S.Text>
            <S.ButtonContainer>
                <S.Button secondarybtn={true} onClick={handleOpen}>
                    Preview Information
                </S.Button>
                <S.Button secondarybtn={false} type="submit" onClick={handleSubmit}>
                    Submit Form
                </S.Button>
            </S.ButtonContainer>
            <Modal sx={{ zIndex: '10000' }} open={open} onClose={handleClose}>
                <S.ModalWrapper>
                    <S.Modal>
                        <Questionaire />
                        <S.ModalButtonWrapper>
                            <S.IconBtn onClick={handleClose}>
                                <S.CrossSimpleIcon />
                            </S.IconBtn>
                        </S.ModalButtonWrapper>
                    </S.Modal>
                </S.ModalWrapper>
            </Modal>
        </S.Container>
    );
};
export default ConfirmationModal;
